// extracted by mini-css-extract-plugin
export var scrollArea = "_ol-0";